import React from 'react';
import { Building2, Home, Calendar, Shield, ArrowRight } from 'lucide-react';
import { services } from '../../data/mock';

const iconMap = {
  Building2: Building2,
  Home: Home,
  Calendar: Calendar,
  Shield: Shield,
};

const ServicesSection = () => {
  return (
    <section id="services" className="relative py-24 lg:py-32">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#00D4FF]/5 to-transparent pointer-events-none" />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-2xl mb-16">
          <span className="text-[#00D4FF] text-sm font-semibold tracking-wider uppercase mb-4 block">
            Our Services
          </span>
          <h2 className="text-3xl lg:text-5xl font-bold text-white mb-6">
            Comprehensive Security Solutions
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed">
            From commercial properties to executive protection, we deliver elite armed
            security services tailored to your specific needs.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative bg-gradient-to-br from-white/[0.05] to-transparent border border-white/10 p-8 lg:p-10 hover:border-[#00D4FF]/50 transition-all duration-500 hover:shadow-[0_0_50px_rgba(0,212,255,0.1)]"
              >
                {/* Corner accent */}
                <div className="absolute top-0 right-0 w-16 h-16 overflow-hidden">
                  <div className="absolute top-0 right-0 w-24 h-24 bg-[#00D4FF]/10 rotate-45 translate-x-12 -translate-y-12 group-hover:bg-[#00D4FF]/20 transition-colors duration-500" />
                </div>

                {/* Number */}
                <span className="text-6xl font-bold text-white/5 absolute top-4 right-6">
                  0{index + 1}
                </span>

                {/* Icon */}
                <div className="w-16 h-16 flex items-center justify-center bg-[#00D4FF]/10 mb-6 group-hover:bg-[#00D4FF] transition-all duration-500">
                  <Icon className="w-8 h-8 text-[#00D4FF] group-hover:text-black transition-colors duration-500" strokeWidth={1.5} />
                </div>

                {/* Content */}
                <h3 className="text-xl lg:text-2xl font-bold text-white mb-4">
                  {service.title}
                </h3>
                <p className="text-gray-400 leading-relaxed mb-6">
                  {service.description}
                </p>

                {/* Link */}
                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 text-[#00D4FF] font-medium group/link"
                >
                  Learn More
                  <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
